<template>
    <div class="EffectiveRiskProfilesTooltipLabel">
        <VMenu
            v-if="riskProfileNames.length > 0"
            :delay="{ show: 300, hide: 100 }"
            :placement="placement"
            popper-class="EffectiveRiskProfilesTooltipLabel__tooltip"
        >
            <div class="EffectiveRiskProfilesTooltipLabel__label tooltip-target">
                {{ label }}
            </div>
            <template #popper>
                <div class="EffectiveRiskProfilesTooltipLabel__popoverTitle">
                    Risk Profiles
                </div>
                <div
                    v-for="(name,index) in riskProfileNames"
                    :key="index"
                    class="EffectiveRiskProfilesTooltipLabel__popoverGroupName"
                >
                    {{ name }}
                </div>
            </template>
        </VMenu>
        <div v-else class="EffectiveRiskProfilesTooltipLabel__label">
            {{ showLabelPrefix ? 'Risk Profile:' : '' }} none
        </div>
    </div>
</template>
<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import { Menu as VMenu } from 'floating-vue';

    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    import { Badge } from '@evidentid/dashboard-commons/components/Badge';

    @Component({
        components: { Badge, FontAwesomeIcon, VMenu },
    })
    export default class EffectiveRiskProfilesTooltipLabel extends Vue {
        @Prop({ type: Array, default: () => [] })
        private riskProfileNames!: string[];

        @Prop({ type: String, default: 'left' })
        private placement!: string;

        @Prop({ type: Boolean, default: true })
        private showLabelPrefix!: boolean;

        private get label(): string {
            return `${this.showLabelPrefix ? 'Risk Profiles:' : ''} ${this.riskProfileNames.join(' + ')}`;
        }
    }
</script>
